module.exports = __webpack_public_path__ + "static/img/case11.3989320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case11.jpg
// module id = /sE2
// module chunks = 0